import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    root: {
      backgroundColor: 'white',
      border: `1px solid ${theme.palette.grey.A100}`,
      borderRadius: 3,
      cursor: 'pointer',
      display: 'inline-block',
      position: 'relative',
      outline: 'none',
      width: '100%',
      padding: '11px 15px',
      fontSize: 16,
      fontFamily: 'Open Sans, sans-serif',
      color: theme.palette.text.primary,
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      backgroundImage: `linear-gradient(
      45deg,
      transparent 50%, 
      ${theme.palette.grey.A200} 50%),
      linear-gradient(135deg, ${theme.palette.grey.A200} 50%, transparent 50%)`,
      backgroundPosition: 'calc(100% - 25px) calc(50% - 1px), calc(100% - 15px) calc(50% - 1px)',
      backgroundSize: '10px 9px, 10px 9px',
      backgroundRepeat: 'no-repeat',
      '&:focus': {
        backgroundImage: `linear-gradient(
        45deg,
        ${theme.palette.secondary.main} 50%,
        transparent 50%),
        linear-gradient(135deg, transparent 50%, ${theme.palette.secondary.main} 50%)`,
        backgroundPosition: 'calc(100% - 15px) calc(50% - 3px), calc(100% - 25px) calc(50% - 3px)',
        backgroundSize: '10px 9px, 10px 9px',
        backgroundRepeat: 'no-repeat',
        border: `2px solid ${theme.palette.secondary.main}`,
        outline: 0,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        padding: '14px 15px',
      },
      [theme.breakpoints.down('xs')]: {
        backgroundPosition: 'calc(100% - 12px) calc(50% - 0px), calc(100% - 6px) calc(50% - 0px)',
        backgroundSize: '7px 8px, 7px 8px',
        '&:focus': {
          backgroundPosition: 'calc(100% - 6px) calc(50% - 1px), calc(100% - 12px) calc(50% - 1px)',
          backgroundSize: '7px 8px, 7px 8px',
        },
      },
    },
  }),
);

interface Props {
  onChange: any;
  name?: string | undefined;
  items: any;
  value: string | number;
  defaultValue?: string | undefined;
  required?: boolean | undefined;
  className?: any;
  inputRef?: React.Ref<any>;
}

const Select: React.FC<Props> = ({ onChange, name, items, value, defaultValue, required, className, inputRef }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <select
        onChange={onChange}
        name={name}
        value={value}
        required={required}
        className={clsx(classes.root, className)}
        ref={inputRef}
      >
        {defaultValue && <option>{defaultValue}</option>}
        {items.map((item: any, index: number) => (
          <option key={item.value || index} value={item.value} disabled={item.disabled}>
            {item.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
